import { defineComponent as _defineComponent } from 'vue'
import router, { getCurrentPath, getCurrentTopic } from '@/router/index';
import useStore from '@/utils/store/common';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router/composables';
import links from './links/sidebarLinks';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationSidebar',
  setup(__props) {

const route = useRoute();
const store = useStore();

let backgroundTopic = '';
const display = ref(false);
const isLinkMenuCollapsed = ref(false);
const topic = ref(getCurrentTopic());

function getCurrentUserIsAbleToWrite(featureName: string) {
  return featureName ? store.getters['permissions/getCurrentUserIsAbleTo']('write', featureName) : false;
}

function getCurrentUserIsAbleToRead(featureName: string) {
  return featureName ? store.getters['permissions/getCurrentUserIsAbleTo']('read', featureName) || getCurrentUserIsAbleToWrite(featureName) : false;
}

function filterItemCurrentUserIsAbleToRead(item: any) {
  if (item.children?.filter(filterItemCurrentUserIsAbleToRead).length) {
    item.children = item.children.filter(filterItemCurrentUserIsAbleToRead);
    return true;
  }
  return getCurrentUserIsAbleToRead(item.permission_id);
}

const items = computed(() => links.filter(filterItemCurrentUserIsAbleToRead));
const currentItem = computed(() => items.value.find((item: any) => item.topic === topic.value));
const updateDisplay = computed(() => display.value && route.path !== '/permissions-errors' && items.value);

function isLinkActive(url: string) {
  return url.includes(getCurrentPath());
}

function isGroupActive(groupName: string) {
  return getCurrentPath().includes(groupName);
}

function updateURL(url: string) {
  if (url !== getCurrentPath()) {
    router.push({
      path: url
    });
  }
}

function updateTopic(item: any, fromLink: boolean) {
  if (fromLink || (isLinkMenuCollapsed.value === false && topic.value === item.topic)) {
    isLinkMenuCollapsed.value = true;
  } else {
    isLinkMenuCollapsed.value = false;
  }
  topic.value = item.topic;

  // const redirectURL = item.children.find((child: any) => child.url).url;
  // if (redirectURL) {
  //   const [activeTopicName, redirectTopicName] = [getCurrentPath().split('/')[1], redirectURL.split('/')[1]];
  //   if (activeTopicName !== redirectTopicName) {
  //     this.updateURL(redirectURL);
  //   }
  // }
}

function topicLogos(itemTopic: string) {
  return itemTopic === backgroundTopic ? itemTopic : `${itemTopic}-idle`;
}

watch(
  () => route,
  () => {
    const { path } = router.currentRoute;
    display.value = false;
    const topicName = path.split('/')[1] || '';
    if (route.path !== '/permissions-errors' && items) {
      const newItem = items.value.find(item => item.topic === topicName);
      if (newItem) {
        updateTopic(newItem, true);
        topic.value = topicName;
        backgroundTopic = topicName;
        display.value = true;
      }
    }
  },
  {
    immediate: true,
    deep: true
  }
);

return { __sfc: true,route, store, backgroundTopic, display, isLinkMenuCollapsed, topic, getCurrentUserIsAbleToWrite, getCurrentUserIsAbleToRead, filterItemCurrentUserIsAbleToRead, items, currentItem, updateDisplay, isLinkActive, isGroupActive, updateURL, updateTopic, topicLogos }
}

})